<template>
  <router-link v-if="routePath" :to="routePath">
    <span class="text-blue-900 font-semibold hover:text-blue-700 hover:underline">
      {{ params.value }}
    </span>
  </router-link>
  <span v-else>{{ params.value }}</span>
</template>

<script>
export default {
  name: 'CC_Router_Link',
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  computed: {
    routePath() {
      if (this.params.to) {
        return typeof this.params.to === 'function'
          ? this.params.to(this.params)
          : this.params.to;
      }
      return null;
    },
  },
};
</script>
